import "./style.css"

export const ButtonHome = ( {text, event} )=>{

    return <button onClick={event} className="button-home font-size-4 font-weight-2 font-color-4">{text}</button>
}

export const ButtonStart = ( {text, event} )=>{

    return <button onClick={event} className="button-start font-size-4 font-weight-2 font-color-7">{text}</button>
}

export const ButtonEnterValue = ( {text} )=>{
    return <button type="submit" className="button-enter-value font-size-4 font-weight-2 font-color-4">{text}</button>
}

export const ButtonAll = ( {text, event, nav} )=>{
    return( 
       nav === "Todos" ?(
            <button onClick={event} className="buttton-all checked font-size-4 font-weight-2 font-color-7">{text}</button>
        ):(
            <button onClick={event} className="buttton-all font-size-4 font-weight-2 font-color-7">{text}</button>
        )
    )
}

export const ButttonsEntrada = ( {text, event, nav} )=>{
    return (
            nav === "Entradas" ?(
                <button onClick={event} className="butttons-expenses checked font-size-4 font-weight-2 font-color-7">{text}</button>
            ):(
                <button onClick={event} className="butttons-expenses font-size-4 font-weight-2 font-color-7">{text}</button>
            )
        )
}

export const ButttonsDespesa = ( {text, event, nav} )=>{
    return (
            nav === "Despesas" ?(
                <button onClick={event} className="butttons-expenses checked font-size-4 font-weight-2 font-color-7">{text}</button>
            ):(
                <button onClick={event} className="butttons-expenses font-size-4 font-weight-2 font-color-7">{text}</button>
            )
        )
}



